

<!-- booker form - values stored in booker obj in addBooking -->
<form *ngIf="bookingAmendSection === 'booker' || bookingAmendSection === ''" #form="ngForm" name="formBooker"
  class="" ng novalidate>

  <div class="panel panelPaymentOptionEmail">
    <div class="flex-always flex--space-between margin-bottom-16">
      <h5 class="margin-top-0 margin-bottom-0 text-dark-blue">{{appCopy.panelHeader['yourDetailsTitle'+selectedLanguage]}}</h5>
      <a *ngIf="userLoggedIn && bookingType !== 'amend'" href="javascript:void(0);"
        (click)="logout()">{{appCopy.panelHeader['linkLogOut'+selectedLanguage]}}</a>
    </div>
    <div class="payment-login margin-bottom-16">
      <div class="form-group margin-bottom-0">
        <input class="form-control"
          [ngClass]="{ 'has-error' : bookerEmail.dirty && bookerEmail.invalid || bookerEmail.dirty && bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect }"
          id="bookerEmail" name="bookerEmail" type="email" #bookerEmail="ngModel" [(ngModel)]="bookerData.emailAddress"
          [readonly]="userLoggedIn && (bookingType !== 'amend' || !user.userDetails.userPermissions.showAdminFeatures)"
          (blur)="verifiyAccount(bookerEmail.value)" (keyup)="resetValidationExpressCheckout()" autocomplete="off" required appCheckEmpty>
        <label class="control-label"
          for="bookerEmail">{{appCopy.panelHeader['bookerEmailLabel'+selectedLanguage]}}</label>
        <i class="icon control-validation-state"></i>

        <p class="help-block text-danger"
          *ngIf="bookerEmail.dirty && bookerEmail.invalid && !bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect">
          {{appCopy.panelHeader['errorTextBookerEmailRequired'+selectedLanguage]}}</p>
        <p class="help-block text-danger" *ngIf="bookerEmail.dirty && bookerEmail.errors?.pattern">
          {{appCopy.panelHeader['errorTextBookerEmailInvalid'+selectedLanguage]}}</p>
      </div>

      <div class="reveal reveal--small">
        <div class="reveal__content">
          <div class="panel panel-default margin-bottom-0">
            <div class="panel-body">
              <div class="row">
                <p class="col-lg-6 col-md-6 text-caption-large">
                  {{appCopy.panelHeader['welcomeBack'+selectedLanguage].replace('%s', userName)}}<br>
                </p>
                <div class="col-lg-6 col-md-6">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="form-group margin-bottom-0">
                        <input class="form-control"
                          [ngClass]="{ 'has-error' : loginPassword.invalid && loginPassword.dirty }" id="loginPassword"
                          name="loginPassword" type="password" #loginPassword="ngModel" ngModel alert-caps-lock
                          appCheckEmpty (keyup.enter)="inlineLogin(bookerEmail.value, loginPassword.value)">
                        <label class="control-label"
                          for="loginPassword">{{appCopy.panelHeader['loginPasswordLabel'+selectedLanguage]}}</label>
                        <i class="icon control-validation-state"></i>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <button  [ngClass]="{'Buttonloading' : showLoginLoader }" class="btn btn-primary btn-lg btn-block" type="button"
                        (click)="inlineLogin(bookerEmail.value, loginPassword.value)"
                        [disabled]="loginPassword.value === '' || showLoginLoader">
                        <!-- <div class="loader-container-btn" *ngIf="showLoginLoader">
                          <div class="loader loader--white">
                            <svg class="circular" viewBox="25 25 50 50">
                              <circle class="path" cx="50" cy="50" r="20" />
                            </svg>
                          </div>
                        </div> -->
                        <span *ngIf="!showLoginLoader">{{appCopy.panelHeader['buttonSubmit'+selectedLanguage]}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <a href="javascript:void(0);" class="loginSkip" (click)="skiplogin()"
                    [appRevealToggle]="showLogin && !userLoggedIn ? 'open' : 'closed'">{{appCopy.panelHeader['skipAsGuestLabel'+selectedLanguage]}}</a>
                </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- <div *ngIf="showOptOutMarketingEnrolment"
      class="checkbox checkbox--default checkbox--small checkbox--reverse margin-bottom-16">
      <input type="checkbox" name="optOutMarketingEnrolment" id="optOutMarketingEnrolment"
        #optOutMarketingEnrolment="ngModel" [ngModel]="false || (formData.set && (this.formData.data && this.formData.data.bookerForm.optOutMarketingEnrolment))">
      <label for="optOutMarketingEnrolment" style="color:#00005A;"
        class="text-caption">{{appCopy.panelHeader['optOutMarketingEnrolmentCheckLabel'+selectedLanguage]}}</label>
    </div> -->

  </div>
  <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0 hasSmsMarketingEnrolment">
    <input type="checkbox" name="hasSmsMarketingEnrolment" id="hasSmsMarketingEnrolment"
      #HasSmsMarketingEnrolment="ngModel" [ngModel]='true'>
    <label for="hasSmsMarketingEnrolment" class="text-caption">
      <span>
        <b>{{appCopy.panelHeader['hasSmsMarketingEnrolmentCheckLabel'+selectedLanguage]}}</b>
        <span>{{appCopy.panelHeader['hasSmsMarketingEnrolmentChecMsg'+selectedLanguage]}}</span>
      </span>
    </label>
  </div>
</div>

  <div class="panel paymentScreen padding-bottom-0 margin-bottom-0">
    <div class="row">
      <div class="col-xs-12">
        <div class="flex-always margin-bottom-8">
          <h5 class="text-dark-blue">{{appCopy.panelHeader['bookerPanelHeading'+selectedLanguage]}}</h5>
          <!-- <div class="bagtooltip margin-left-8">
            <span class="icon-span icon-span-small tooltip-trigger-text">
              <span class="icon-information icon-black icon_12">
              </span>
            </span>
            <span
              class="tooltiptext tooltip-top tooltip-passenger">{{appCopy.panelHeader['bookerFirstNameTooltipContent'+selectedLanguage]}}</span>
          </div> -->
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : bookerFirstName.dirty && bookerFirstName.invalid || bookerFirstName.errors?.incorrect }"
            id="bookerFirstName" name="bookerFirstName" type="text" #bookerFirstName="ngModel"
            [(ngModel)]="bookerData.firstName" [pattern]="letterPattern" required appCheckEmpty>
          <label class="control-label"
            for="bookerFirstName">{{appCopy.panelHeader['bookerFirstNameLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="bookerFirstName.dirty && bookerFirstName.errors?.pattern">
            {{appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage]}}</p>
          <p class="help-block text-danger"
            *ngIf="bookerFirstName.dirty && bookerFirstName.invalid && !bookerFirstName.errors?.pattern && !bookerFirstName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerFirstNameRequires'+selectedLanguage]}}</p>
          <p class="help-block text-danger" *ngIf="bookerFirstName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerFirstNameRequires'+selectedLanguage]}}
          </p>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : bookerLastName.dirty && bookerLastName.invalid || bookerLastName.errors?.incorrect }"
            id="bookerLastName" name="bookerLastName" type="text" #bookerLastName="ngModel"
            [(ngModel)]="bookerData.lastName" [pattern]="letterPattern" required appCheckEmpty>
          <label class="control-label"
            for="bookerLastName">{{appCopy.panelHeader['bookerLastNameLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="bookerLastName.dirty && bookerLastName.errors?.pattern">
            {{appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage]}}</p>
          <p class="help-block text-danger"
            *ngIf="bookerLastName.dirty && bookerLastName.invalid && !bookerLastName.errors?.pattern && !bookerLastName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerLastNameRequires'+selectedLanguage]}}</p>
          <p class="help-block text-danger" *ngIf="bookerLastName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerLastNameRequires'+selectedLanguage]}}</p>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="multiple-inputs clearfix">
          <div class="col-xs-2 col-sm-2 form-group with-select">
            <div class="with-select__custom-value">+{{contactCountryCode.value}}</div>
            <ng-select class="form-control form-control--no-label"
              [ngClass]="{ 'has-error' : contactPhone.errors?.incorrect || contactPhone.invalid && contactPhone.dirty }"
              id="contactCountryCode" name="contactCountryCode" #contactCountryCode="ngModel"
              [(ngModel)]="bookerData.countryCode" (ngModelChange)="validatePhoneNumber($event, contactPhone.value)"
              [clearable]="false"
              [items]="countryCodes.all" [notFoundText]="appCopy.panelHeader['bookerCountryNotFound'+selectedLanguage]" groupBy="label" bindLabel="displayText" bindValue="countryCode"
              >

            </ng-select>
          </div>
          <div class="col-xs-10 col-sm-10 form-group">
            <input class="form-control form-control--no-label"
              [ngClass]="{ 'has-error' : contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect }"
              type="tel" id="contactPhone" name="contactPhone" #contactPhone="ngModel"
              placeholder="{{appCopy.panelHeader['contactPlaceholder'+selectedLanguage]}}"
              [(ngModel)]="bookerData.phoneNumber"
              (blur)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)" required appCheckEmpty>
            <i class="icon control-validation-state"></i>
          </div>
          <div class="col-xs-12">
            <p class="help-block text-danger"
              *ngIf="contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect">
              {{appCopy.panelHeader['errorTextContact'+selectedLanguage]}}</p>
          </div>
        </div>
        <p class="text-caption-large margin-bottom-16 text-dark-blue">
          {{appCopy.panelHeader['contentContactNumber'+selectedLanguage]}}
        </p>
      </div>

      <div class="col-xs-12" *ngIf="showSetPassword">
        <div class="form-group fadeIn">
          <input class="form-control" [ngClass]="{ 'has-error' : setPassword.dirty && setPassword.invalid }"
            id="setPassword" name="setPassword" type="password" #setPassword="ngModel" [ngModel]='newUserSetPassword' alert-caps-lock
            appCheckEmpty (blur)="validatePassword(setPassword.value)">
          <label class="control-label"
            for="setPassword">{{appCopy.panelHeader['setPasswordLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="setPassword.dirty && setPassword.errors?.pattern">
            {{appCopy.panelHeader['errorTextSetPassword'+selectedLanguage]}}</p>
        </div>
      </div>
    </div>
  </div>
</form>
